/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// For loading some useful utilities like axios an lodash
require( './bootstrap' );

$.trumbowyg.svgPath = '/js/ui/icons.svg';

document.addEventListener( 'DOMContentLoaded',() => {
    ( document.querySelectorAll( '.message.closeable .delete' ) || [] ).forEach( $delete => {
        $notification = $delete.parentNode.parentNode;

        $delete.addEventListener( 'click',() => {
            $notification.parentNode.removeChild( $notification );
        } );
    } );
} );

$( document ).ready( function() {
    $( '.datepicker' ).datepicker( {
        autoHide: true,
        zIndex: 10000,
    } );

    $( '.nav-toggle' ).on( 'click touchstart',function( event ) {
        let $target = $( $( this ).data( 'target' ) );
        $target.slideToggle( 'fast' );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( 'body' ).on( 'click touchstart','.show-hide-toggle',function( event ) {
        let $target = $( $( this ).data( 'target' ) );
        $target.slideToggle( 'fast' );
        $( this )
            .find( '.on' )
            .toggleClass( 'hide' );
        $( this )
            .find( '.off' )
            .toggleClass( 'hide' );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( 'body' ).on( 'click touchstart','.togglefullscreen',function( event ) {
        let $elem = $( this );
        let $target = $( $elem.data( 'target' ) );
        let $text = $elem.data( 'text' );
        let $swapText = $elem.data( 'swap-text' );
        $target.toggleClass( 'fullscreen' );
        if ( $target.hasClass( 'fullscreen' ) ) {
            $elem.html( $swapText );
            $target.find( '.title .hidden' ).show();
        } else {
            $elem.html( $text );
            $target.find( '.title .hidden' ).hide();
        }
        event.stopPropagation();
        event.preventDefault();
    } );

    $( 'body' ).on( 'click touchstart','.fullscreen .ajax-modal-button',function(
        event
    ) {
        let $parent = $( this ).parents( '.fullscreen' );
        $parent.removeClass( 'fullscreen' );
        $parent.find( '.title .hidden' ).hide();
        let $button = $parent.find( '.togglefullscreen' );
        $button.html( $button.data( 'text' ) );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( '.wysiwyg' ).trumbowyg( {
        autogrow: false,
        autogrowOnEnter: true,
        urlProtocol: true,
        removeformatPasted: true,
        tagsToRemove: [ 'script','link' ],
        btns: [
            [ 'formatting' ],
            [ 'strong','em','del' ],
            [ 'unorderedList','orderedList' ],
            [ 'justifyLeft','justifyCenter','justifyRight','justifyFull' ],
            [ 'link' ],
            [ 'removeformat' ],
            [ 'fullscreen' ],
            [ 'viewHTML' ],
        ],
        plugins: {
            allowTagsFromPaste: {
                allowedTags: [ 'h3','p','br','ul','ol','li','a' ],
            },
        },
    } );

    $( 'body' ).on( 'click touchstart','.modal-button',function( event ) {
        let target = $( this ).data( 'target' );
        $( 'html' ).addClass( 'is-clipped' );
        $( target ).addClass( 'is-active' );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( 'body' ).on( 'click touchstart','.ajax-modal-button',function( event ) {
        let target = $( this ).data( 'target' );
        let $url = $( this ).data( 'url' );
        let $this = $( this );
        if ( $this.hasClass( 'floating' ) ) {
            $this
                .addClass( 'loading' )
                .find( '.icon' )
                .addClass( 'loader' )
                .removeClass( 'icon' )
                .find( 'i' )
                .hide();
        }
        $( target )
            .find( '.ajaxcontent' )
            .load( $url,function() {
                $( target )
                    .find( '.loader' )
                    .hide();
                if ( $this.hasClass( 'floating' ) ) {
                    $this
                        .removeClass( 'loading' )
                        .find( '.loader' )
                        .addClass( 'icon' )
                        .removeClass( 'loader' )
                        .find( 'i' )
                        .show();
                }
                $( 'html' ).addClass( 'is-clipped' );
                $( target ).addClass( 'is-active' );
                $( target )
                    .find( '.wysiwyg' )
                    .trumbowyg( {
                        autogrow: false,
                        autogrowOnEnter: true,
                        urlProtocol: true,
                        removeformatPasted: true,
                        tagsToRemove: [ 'script','link' ],
                        btns: [
                            [ 'formatting' ],
                            [ 'strong','em','del' ],
                            [ 'unorderedList','orderedList' ],
                            [ 'justifyLeft','justifyCenter','justifyRight','justifyFull' ],
                            [ 'link' ],
                            'table',
                            [ 'removeformat' ],
                            [ 'fullscreen' ],
                            [ 'viewHTML' ],
                        ],
                        plugins: {
                            allowTagsFromPaste: {
                                allowedTags: [ 'h3','p','br','ul','ol','li','a' ],
                            },
                        },
                    } );
                $( target )
                    .find( '.datepicker' )
                    .datepicker( {
                        autoHide: true,
                        zIndex: 10000,
                    } );
            } );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( 'body' ).on( 'click touchstart','.modal-close',function() {
        $( 'html' ).removeClass( 'is-clipped' );
        $( this )
            .parent()
            .removeClass( 'is-active' );
        $( this )
            .closest( '.ajaxcontent' )
            .empty();
    } );

    $( 'body' ).on(
        'click touchstart',
        '.modal-card-head .delete, .modal-card-foot .cancel-button',
        function() {
            $( 'html' ).removeClass( 'is-clipped' );
            $( '.modal' ).removeClass( 'is-active' );
            $( this )
                .closest( '.ajaxcontent' )
                .empty();
        }
    );

    $( document ).on( 'keyup',function( event ) {
        if ( event.keyCode === 27 ) {
            $( 'html' ).removeClass( 'is-clipped' );
            $( '.modal' ).removeClass( 'is-active' );
        }
    } );

    $( '.js-tabs li a' ).click( function( event ) {
        event.stopPropagation();
        event.preventDefault();
        let tab_id = $( this ).attr( 'data-tab' );

        $( '.js-tabs li' ).removeClass( 'is-active' );
        $( '.tab-content' ).removeClass( 'is-active' );

        $( this )
            .parent( 'li' )
            .addClass( 'is-active' );

        $( '#' + tab_id ).addClass( 'is-active' );

        if ( history.pushState ) {
            history.pushState( null,null,'#' + tab_id );
        } else {
            location.hash = '#' + tab_id;
        }

        // Here is a fix to DataTables auto width: 0 when the element is not visible. Caused by the tabs.
        let tabContainerId = '#' + $( event.target ).data( 'tab' );

        $( tabContainerId ).find( '.dataTable' )
            .width(
                $( tabContainerId ).find( '.dataTables_wrapper' )
                    .width()
            );

        // $(tabContainerId).find('.dataTable').DataTable().columns.adjust();
    } );

    // here we are looking for our tab header
    let $hash = window.location.hash;
    let $elements = $( 'a[href="' + $hash + '"]' );
    if ( $elements.length !== 0 ) {
        $elements.click();
    }

    function loadData( elem,url ) {
        $.ajax( {
            type: 'GET',
            url: url,
            beforeSend: function() {
                elem.find( '.content-holder' ).empty();
                elem.find( '.loader' ).show();
            },
            success: function( response ) {
                elem.find( '.content-holder' ).html( response );
                elem.find( '.loader' ).hide();
                if ( elem.hasClass( 'filterable' ) ) {
                    initLists( elem.get( 0 ) );
                }
            },
            complete: function() {
                elem.find( '.loader' ).hide();
            },
            error: function() { },
        } );
    }

    $.each( $( '.load-content' ),function() {
        loadData( $( this ),$( this ).data( 'url' ) );
    } );

    $( 'body' ).on( 'click','.load-content .panel-tabs a, .load-content nav a',function( event ) {
        let $this = $( this );
        let $parent = $this.closest( '.load-content' );
        $this.siblings().removeClass( 'is-active' );
        $this.addClass( 'is-active' );
        $parent.find( '.loader' ).show();
        loadData( $parent,$this.attr( 'href' ) );
        event.stopPropagation();
        event.preventDefault();
    } );

    $( '#superadmin' ).change( function() {
        if ( this.checked ) {
            $( '#role-account-admin' )
                .attr( 'disabled','disabled' )
                .closest( 'p' )
                .fadeOut( 'fast' );
            $( '#role-account-employee' )
                .attr( 'disabled','disabled' )
                .closest( 'p' )
                .fadeOut( 'fast' );
            $( '#role-osp-admin' )
                .attr( 'disabled','disabled' )
                .closest( 'p' )
                .fadeOut( 'fast' );
        } else {
            $( '#role-account-admin' )
                .removeAttr( 'disabled' )
                .closest( 'p' )
                .fadeIn( 'fast' );
            $( '#role-account-employee' )
                .removeAttr( 'disabled' )
                .closest( 'p' )
                .fadeIn( 'fast' );
            $( '#role-osp-admin' )
                .removeAttr( 'disabled' )
                .closest( 'p' )
                .fadeIn( 'fast' );
        }
    } );

    $( '#projects-select option:not(:selected)' )
        .attr( 'disabled','disabled' )
        .hide();

    $( '#admins-select' ).on( 'click touchstart',function() {
        $( '#projects-select option:selected' ).removeAttr( 'selected' );

        if ( $( '#admins-select :selected' ).length > 0 ) {
            $( '#projects-select option' )
                .attr( 'disabled','disabled' )
                .hide();
        } else {
            $( '#projects-select option' )
                .removeAttr( 'disabled' )
                .hide();
        }
        if ( $( '#admins-select :selected' ).length > 1 ) {
            $.each( $( this ).val(),function( index,value ) {
                $( '#projects-select' )
                    .find( '.admin-' + value )
                    .removeAttr( 'disabled' )
                    .show();
            } );
        } else {
            $( '#projects-select' )
                .find( '.admin-' + $( '#admins-select :selected' ).val() )
                .removeAttr( 'disabled' )
                .show();
        }
    } );

    $( 'input[name=role]' ).change( function() {
        if ( $( this ).val() === 'Account Admin' || $( this ).val() === 'Account User' ) {
            $( '#superadmin' )
                .closest( '.columns' )
                .slideUp( 'fast' );
            $( '#admins-select' )
                .removeAttr( 'multiple' )
                .parent( 'span' )
                .removeClass( 'multi-select' )
                .addClass( 'select' );
        } else {
            $( '#superadmin' )
                .closest( '.columns' )
                .slideDown( 'fast' );
            $( '#admins-select' )
                .attr( 'multiple','multiple' )
                .parent( 'span' )
                .addClass( 'multi-select' )
                .removeClass( 'select' );
        }
    } );


    $( 'body' ).on( 'change','.fileuploadfield',function() {
        let $field = $( this );
        if ( $field[ 0 ].files.length > 0 ) {
            $field.closest( '.file' ).addClass( 'has-name' );
            $field
                .siblings( '.file-name' )
                .text( $field[ 0 ].files[ 0 ].name )
                .toggleClass( 'hide' );
        }
    } );
} );

function initLists( listContainer ) {
    let listOptions = {
        listClass: 'filter-list',
        searchClass: 'filter-search',
        indexAsync: true,
        valueNames: [ { data: [ 'name' ] },{ data: [ 'extra' ] } ],
    };
    let list = new List( listContainer,listOptions );

    return list;
}

document.addEventListener( 'DOMContentLoaded',function() {
    // Get all "navbar-burger" elements
    let $navbarBurgers = Array.prototype.slice.call(
        document.querySelectorAll( '.navbar-burger' ),
        0
    );

    // Check if there are any navbar burgers
    if ( $navbarBurgers.length > 0 ) {
        // Add a click event on each of them
        $navbarBurgers.forEach( function( $el ) {
            $el.addEventListener( 'click',function() {
                // Get the target from the "data-target" attribute
                let target = $el.dataset.target;
                let $target = document.getElementById( target );

                // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                $el.classList.toggle( 'is-active' );
                $target.classList.toggle( 'is-active' );
            } );
        } );
    }
} );
